import { requiredCommonFields } from '@/config/contracts'
import { isRoadmapInvalid, round } from '@/utils'

export const noDocumentsCheckFn = contract => {
  const fields = [
    'code',
    'name',
    'customer_id',
    'performer_id',
    'contract_status_id'
  ]

  // check common info
  if (fields.some(f => !contract[f])) {
    return {
      warning:
        'Необходимо указать шифр, номер, название, статус, заказчика и исполнителя',
      disabled: true
    }
  }

  return {
    warning: null,
    disabled: false
  }
}

export const guaranteeLetterCheckFn = contract => {
  const { contract_job_types, roadmaps } = contract

  // check common info
  if (requiredCommonFields.some(f => !contract[f])) {
    return {
      warning:
        'Необходимо указать шифр, номер, название, дату заключения, заказчика и исполнителя',
      disabled: true
    }
  }
  if (!contract_job_types.length) {
    return {
      warning: 'Необходимо указать как минимум один вид работ',
      disabled: true
    }
  }
  // check roadmap
  if (!roadmaps.length) {
    return {
      warning: 'В календарном плане должен быть как минимум один этап',
      disabled: true
    }
  }
  if (roadmaps.some(isRoadmapInvalid)) {
    return {
      warning:
        'Необходимо указать корректные сумму, сроки и название для каждого этапа календарного плана',
      disabled: true
    }
  }

  return {
    warning: null,
    disabled: false
  }
}

export const fullCheckFn = contract => {
  const {
    contract_job_types,
    roadmaps,
    prepaid_amount,
    retention_amount
  } = contract

  // check common info
  if (requiredCommonFields.some(f => !contract[f])) {
    return {
      warning:
        'Необходимо указать шифр, номер, название, статус, дату заключения, заказчика и исполнителя',
      disabled: true
    }
  }
  if (!contract_job_types.length) {
    return {
      warning: 'Необходимо указать как минимум один вид работ',
      disabled: true
    }
  }
  // check roadmap
  if (!roadmaps.length) {
    return {
      warning: 'В календарном плане должен быть как минимум один этап',
      disabled: true
    }
  }
  if (roadmaps.some(isRoadmapInvalid)) {
    return {
      warning:
        'Необходимо указать корректные сумму, сроки и название для каждого этапа календарного плана',
      disabled: true
    }
  }

  // check prepaid
  const prepaidChecking = checkPrepaid(contract)
  if (prepaidChecking.disabled) return prepaidChecking

  // check retention
  const retentionChecking = checkRetention(contract)
  if (retentionChecking.disabled) return retentionChecking

  // check prepaid and retention together
  const sum = roadmaps.reduce((prev, r) => prev + r.costs, 0)
  const specialConditionsSum = prepaid_amount + retention_amount
  if (specialConditionsSum > sum) {
    return {
      warning: 'Сумма аванса и ГУ не может превышать сумму договора',
      disabled: true
    }
  }

  return {
    warning: null,
    disabled: false
  }
}

export const checkPrepaid = contract => {
  const {
    roadmaps,
    prepaid,
    prepaid_amount,
    prepaid_condition,
    prepaid_condition_date,
    payment_tasks
  } = contract

  if (prepaid) {
    if (!prepaid_amount || (!prepaid_condition && !prepaid_condition_date)) {
      return {
        warning: 'Необходимо указать сумму и срок получения аванса',
        disabled: true
      }
    }

    const prepaidSum = roadmaps.reduce((prev, r) => prev + r.prepaid_value, 0)

    if (round(prepaidSum, 2) !== round(prepaid_amount, 2)) {
      return {
        warning:
          'Сумма величин аванса по каждому этапу должна совпадать с общей суммой аванса',
        disabled: true
      }
    }

    if (roadmaps.some(r => r.prepaid_value > r.costs)) {
      return {
        warning:
          'Сумма аванса по этапу не может превышать общую стоимость этапа',
        disabled: true
      }
    }

    // check payments tasks
    if (payment_tasks.length) {
      if (payment_tasks.some(t => !t.value || !t.payment_date)) {
        return {
          warning:
            'Необходимо указать дату получения и сумму по всем этапам разбивки аванса',
          disabled: true
        }
      }

      const sum = payment_tasks.reduce((prev, el) => prev + el.value, 0)

      if (sum > prepaid_amount) {
        return {
          warning:
            'Сумма всех этапов разбивки аванса не может превышать общую сумму аванса',
          disabled: true
        }
      }

      if (sum < prepaid_amount) {
        return {
          warning:
            'Сумма всех этапов разбивки аванса должна совпадать с общей суммой аванса',
          disabled: true
        }
      }
    }
  }

  return {
    warning: null,
    disabled: false
  }
}

export const checkRetention = contract => {
  const {
    roadmaps,
    retention,
    retention_amount,
    retention_condition,
    retention_condition_date
  } = contract

  if (retention) {
    if (
      !retention_amount ||
      (!retention_condition && !retention_condition_date)
    ) {
      return {
        warning: 'Необходимо указать сумму и срок получения ГУ',
        disabled: true
      }
    }

    const retentionSum = roadmaps.reduce((prev, r) => prev + r.retention_value, 0)

    if (round(retentionSum, 2) !== round(retention_amount, 2)) {
      return {
        warning:
          'Сумма величин ГУ по каждому этапу должна совпадать с общей суммой ГУ',
        disabled: true
      }
    }

    if (roadmaps.some(r => r.retention_value > r.costs)) {
      return {
        warning: 'Сумма ГУ по этапу не может превышать общую стоимость этапа',
        disabled: true
      }
    }
  }

  return {
    warning: null,
    disabled: false
  }
}
